import './App.css';
import Navbar from './Component/Navbar';
import Mandir from './Component/Mandir';
import Home from './Component/Home';
import Footer from './Component/Footer';
import Events from './Component/Events';
import EventsDetail from './Component/EventsDetail';
import Test from './Component/Test';
import MandirDetail from './Component/MandirDetail';
import Dharmshala from './Component/Dharmshala';
import DharmshalaDetail from './Component/DharamshalaDetail';
import Sadhvi from './Component/Sadhvi';
import Contact from './Component/Contact';
import AdminLogin from './Component/AdminLogin';
import Dashboard from './Component/Dashboard';
import Booking from './Component/Booking';
import Leads from './Component/Leads';
import AddAbout from './Component/AddAbout';
import OfficeBearer from './Component/OfficeBearer';
import ExecutiveMember from './Component/ExecutiveMember';
import PrivcyPolicy from './Component/PrivcyPolicy';
import TermCondition from './Component/TermCondition';
import RefundPolicy from './Component/RefundPolicy';
import BookingCencel from './Component/BookingCencel';
import Facility from './Component/Facility';
import ExeMember from './Component/ExeMember';
import ContactAdmin from './Component/ContactAdmin';
import NearBy from './Component/NearBy';
import ForgotPass from './Component/ForgotPass';
import GuruList from './Component/GuruList';
import Users from './Component/Users';
import About from './Component/AboutUs';
import Function from './Component/Function';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import RouteWrapper from './Wrapper/RouteWrapper';
import OfcBearer from './Component/OfcBearer';
import Room from './Component/Room';
import Donations from './Component/Donations';
import RoomBookings from './Component/RoomBookings';

function App() {
  return (
     <>
        <BrowserRouter>
          <RouteWrapper childComponent={ <Routes>
              <Route index element={
                 <>
                   <Navbar/>
                     <About />
                   <Footer/>
                 </>
              } />
              <Route path='/AdminLogin' Component={AdminLogin} />
              <Route path='/roomBooking' Component={RoomBookings} />
              <Route path='/Leads' Component={Leads} />
              <Route path='/AddAbout' Component={AddAbout} />
              <Route path='/Dharmshala' Component={Dharmshala} />

              <Route path='/Dharmshala/bookingFacilities' Component={Room} />
              {/* <Route path='/Dharmshala/roomBooking' Component={Room} /> */}

              <Route path='/DharmshalaDetail/:id' Component={DharmshalaDetail} />
              <Route path='/Dashboard' Component={Dashboard} />
              <Route path="/Mandir" element={<Mandir />} />
              <Route path="/MandirDetail" element={<MandirDetail />} />
              <Route path="/Events" element={<Events />} />
              <Route path="/EventsDetail/:id" element={<EventsDetail />} />
              <Route path="/Sadhvi" element={<Sadhvi />} />
              <Route path="/Test" element={<Test />} />
              <Route path="/Contact" element={<Contact />} />
              <Route path="/OfficeBearer" element={<OfficeBearer />} />
              <Route path="/ExecutiveMember" element={<ExecutiveMember />} />
              <Route path="/PrivcyPolicy" element={<PrivcyPolicy />} />
              <Route path="/TermCondition" element={<TermCondition />} />
              <Route path="/RefundPolicy" element={<RefundPolicy />} />
              <Route path="/BookingCencel" element={<BookingCencel />} />
              <Route path="/Facility" element={<Facility />} />
              <Route path="/OfcBearer" element={<OfcBearer />} />
              <Route path="/ExeMember" element={<ExeMember />} />
              <Route path="/ContactAdmin" element={<ContactAdmin />} />
              <Route path="/NearBy" element={<NearBy />} />
              <Route path="/ForgotPass" element={<ForgotPass />} />
              <Route path="/GuruList" element={<GuruList />} />
              <Route path="/Users" element={<Users />} />
              <Route path="/Home" element={<About />} />
              <Route path="/Function" element={<Function />} />
              <Route path="/donatisons" element={<Donations />} />
            </Routes>}/>
        </BrowserRouter>
      </>
  );
}

export default App;
